<script>
  import ListHeader from '../../../components/list/Header.vue'
  import * as restfulService from '../../../services/restfulService'

  export default {
    components: {ListHeader},
    data () {
      return {
        isLoadingData: true,
        form: {
          papers: {}
        }
      }
    },
    computed: {
      currentView: function () {
        let route = this.$route
        switch (route.name) {
          case 'event.show.home':
            return 'home'
          case 'event.index.registrations':
            return 'registration'
          default:
            return 'event.index.papers.' + route.params.statusKey
        }
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('event', 'manage', id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
          })
          .catch((err) => {
            console.log(err)
            this.isLoadingData = false
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <ListHeader :title="form.event.title + ' / ' + form.title"
                    back-route="event.index"
                    edit-route-name="event.update.basic-data"
                    :item="form"/>
        <div class="show-box">
            <div class="header">
                <span class="title">Dados da Evento</span>
            </div>
            <div class="content">
                <table width="100%">
                    <tbody>
                    <tr>
                        <td width="33%">
                            <div>Local: <strong>{{form.place.description}}</strong></div>
                            <div>Email Contato: <strong>{{form.contact_email}}</strong></div>
                        </td>
                        <td width="33%">
                            <div>Data de Início: <strong>{{form.start_datetime | dateTimeEnToBr}}</strong></div>
                            <div>Data de Término: <strong>{{form.end_datetime | dateTimeEnToBr}}</strong></div>
                        </td>
                        <td width="33%">
                            <div>Data de Início das Inscrições: <strong>{{form.start_registration_datetime |
                                dateTimeEnToBr}}</strong></div>
                            <div>Data de Término das Inscrições: <strong>{{form.end_registration_datetime |
                                dateTimeEnToBr}}</strong></div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="event-actions">
            <router-link :to="{ name: 'event.show.home', params: { id: form.id, mainEventId: form.event_id } }"
                         class="-button1"
                         title="Início"
                         v-bind:class="{'-current': currentView === 'home'}">
                <div class="event-link-box">
                    <div class="event-box">
                        <i class="fa fa-home"></i>
                        <span>Início</span>
                    </div>
                </div>
            </router-link>
            <router-link
                    :to="{ name: 'event.index.registrations', params: { id: form.id, mainEventId: form.event_id } }"
                    class="-button2"
                    title="Inscrições"
                    v-bind:class="{'-current': currentView === 'registration'}">
                <div class="event-link-box">
                    <div class="event-box">
                        <i class="fa fa-user"></i>
                        <span>Inscrições</span>
                    </div>
                </div>
            </router-link>
            <router-link :to="{ name: 'event.index.papers', params: { id: form.id, statusKey: 'nao_designado' } }"
                         class="-button3"
                         title="Submissões Recebidas"
                         v-bind:class="{'-current': currentView === 'event.index.papers.nao_designado'}">
                <div class="event-link-box">
                    <div class="event-box">
                        <i class="fa fa-file-o"></i>
                        <span>Submissões Recebidas</span>
                        <span class="total">Total: <strong>{{form.papers['nao_designado']}}</strong></span>
                    </div>
                </div>
            </router-link>
            <router-link
                    :to="{ name: 'event.index.papers', params: { id: form.id, statusKey: 'aprovado_pela_triagem' } }"
                    class="-button4"
                    title="Aprovadas pela Triagem"
                    v-bind:class="{'-current': currentView === 'event.index.papers.aprovado_pela_triagem'}">
                <div class="event-link-box">
                    <div class="event-box">
                        <i class="fa fa-file-o"></i>
                        <span>Aprovadas pela Triagem</span>
                        <span class="total">Total: <strong>{{form.papers['aprovado_pela_triagem']}}</strong></span>
                    </div>
                </div>
            </router-link>
            <router-link :to="{ name: 'event.index.papers', params: { id: form.id, statusKey: 'em_avaliacao' } }"
                         class="-button5"
                         title="Submissões Atribuidas"
                         v-bind:class="{'-current': currentView === 'event.index.papers.em_avaliacao'}">
                <div class="event-link-box">
                    <div class="event-box">
                        <i class="fa fa-file-text-o"></i>
                        <span>Submissões Atribuidas</span>
                        <span class="total">Total: <strong>{{form.papers['em_avaliacao']}}</strong></span>
                    </div>
                </div>
            </router-link>
            <router-link :to="{ name: 'event.index.papers', params: { id: form.id, statusKey: 'finalizado' } }"
                         class="-button6"
                         title="Submissões Avaliadas"
                         v-bind:class="{'-current': currentView === 'event.index.papers.finalizado'}">
                <div class="event-link-box">
                    <div class="event-box">
                        <i class="fa fa-file"></i>
                        <span>Submissões Finalizadas</span>
                    </div>
                </div>
            </router-link>
        </div>
        <router-view :event="form"></router-view>
    </div>
</template>

<style lang="scss">
    .show-box {
        margin-bottom: 20px;
        .content {
            padding: 5px;
        }
    }

    .event-actions {
        display: flex;
        justify-content: space-between;
        margin: 20px 0 40px;

        > a {
            width: 15%;
            text-decoration: none;
            padding: 25px 5px;
            text-align: center;
            border-radius: 4px;
            border-bottom: 10px solid transparent;

            i, span {
                display: inline-block;
                width: 100%;
                color: #FFF;
            }
            i {
                font-size: 36px;
                color: rgba(0, 0, 0, .3);
            }
            span {
                font-family: 'Roboto', sans-serif;
                padding-top: 10px;
                font-size: 16px;
                text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.1);
                text-transform: uppercase;
            }

            &.-button1 {
                background-color: #0E9DD9;
            }
            &.-button2 {
                background-color: #74726d;
            }
            &.-button3 {
                background-color: #A384B7;
            }
            &.-button4 {
                background-color: #EE6A5C;
            }
            &.-button5 {
                background-color: #E58432;
            }
            &.-button6 {
                background-color: #7BB941;
            }
            &.-button7 {
                background-color: #ECB238;
            }
            &.-current {
                border-color: rgba(0, 0, 0, .3);
            }

            .total {
                font-size: 24px;
            }

            .event-link-box {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
            }
        }
    }

    .list-component {
        .el-card__search_list {
            margin-bottom: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// Show.vue?14b50180